<div
  class="modal fade"
  bsModal
  #modalResetPassword="bs-modal"
  [config]="{ backdrop: false }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Ανανέωση Κωδικού πρόσβασης</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="modalResetPassword.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        [formGroup]="valForm"
        class="form-validate mb-3"
        role="form"
        name="loginForm"
        novalidate=""
        (submit)="onSubmit()"
      >
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Όνομα χρήστη:</label>
            <div class="input-group with-focus">
              <input
                class="form-control border-right-0"
                id="exampleInputUsername1"
                type="text"
                name="username"
                placeholder="Enter username"
                autocomplete="off"
                formControlName="username"
                required=""
              />
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Κωδικός</label>
            <div class="input-group with-focus">
              <input
                class="form-control border-right-0"
                id="exampleInputPassword1"
                type="password"
                name="password"
                formControlName="password"
                required=""
              />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-lock"></em>
                </span>
              </div>
            </div>
            <app-validation-errors [FormControl]="getControl('password')"></app-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label">Νέος κωδικός</label>
            <div class="input-group with-focus">
              <input
                class="form-control border-right-0"
                id="newPassword"
                type="password"
                name="newPassword"
                formControlName="newPassword"
              />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-lock"></em>
                </span>
              </div>
            </div>
            <app-validation-errors
              [FormControl]="getControl('newPassword')"
            ></app-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label">Επιβεβαίωση νέου κωδικού</label>
            <div class="input-group with-focus">
              <input
                class="form-control border-right-0"
                id="confirmNewPassword"
                type="password"
                name="confirmNewPassword"
                formControlName="confirmNewPassword"
              />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-lock"></em>
                </span>
              </div>
            </div>
            <app-validation-errors [FormControl]="getControl('confirmNewPassword')">
            </app-validation-errors>
          </div>
          <p class="text-warning">{{ passwordRules }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="onSubmit()">Καταχώριση</button>
          <button type="button" class="btn btn-danger" (click)="modalResetPassword.hide()">
            Ακύρωση
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
